import actionTypes from "../actionTypes";
import config from "../../config";

export const getUsers = () => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USERS_FETCH,
  url: config.api.grantUrl + "/users?per_page=9999"
});

export const getUserById = userId => ({
  type: actionTypes.app.API_FETCH,
  receive: actionTypes.USER_FETCH,
  url: config.api.grantUrl + "/users/" + userId
});



// WEBPACK FOOTER //
// ./src/redux/actions/Users.js